import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-atendimento`
    const baseUrlFiltragem = `${baseUrl}/filtragem`

    return {
        index(queryParms) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        autocomplete(queryParms) {
            return repository.get(`${baseUrl}/autocomplete?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorDiaSemana(queryParms) {
            return repository.get(`${baseUrlFiltragem}/dia-semana?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorUnidade(queryParms) {
            return repository.get(`${baseUrlFiltragem}/unidade?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorLocalAtendimento(queryParms) {
            return repository.get(`${baseUrlFiltragem}/local-atendimento?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorClassificacaoRisco(queryParms) {
            return repository.get(`${baseUrlFiltragem}/classificacao-risco?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorDesfecho(queryParms) {
            return repository.get(`${baseUrlFiltragem}/desfecho?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorOcupacao(queryParms) {
            return repository.get(`${baseUrlFiltragem}/ocupacao?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorProfissional(queryParms) {
            return repository.get(`${baseUrlFiltragem}/profissional?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorStatus(queryParms) {
            return repository.get(`${baseUrlFiltragem}/status?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorCid(queryParms) {
            return repository.get(`${baseUrlFiltragem}/cid?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorSexo(queryParms) {
            return repository.get(`${baseUrlFiltragem}/sexo?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorClassificacaoPaciente(queryParms) {
            return repository.get(`${baseUrlFiltragem}/classificacao-paciente?${urlUtil.serialize(queryParms)}`)
        },
    }
}